<template>
  <div id="regist">
    <el-container>
        <el-header><i class="far fa-address-card"></i> 新規登録</el-header>
        <el-main>
        <el-form ref="refFrmRegist" :model="frmRegist" :rules="rules" label-width="160px">
            <el-form-item label="御社名（法人の場合）" prop="corporate_name">
                <el-input placeholder="株式会社アシストパル" v-model="frmRegist.corporate_name"></el-input>
            </el-form-item>
            <el-form-item label="郵便番号" prop="postal_code">
                <el-input placeholder="320-0861" v-model="frmRegist.postal_code"></el-input>
            </el-form-item>
            <el-form-item label="住所" prop="address">
                <el-input placeholder="栃木県宇都宮市西1-4-3" v-model="frmRegist.address"></el-input>
            </el-form-item>
            <el-form-item label="電話番号" prop="tel">
                <el-input placeholder="028-306-2430" v-model="frmRegist.tel"></el-input>
            </el-form-item>
            <el-form-item label="業種" prop="business">
                <el-cascader
                v-model="frmRegist.business"
                :options="business_options"
                :props="{ expandTrigger: 'hover' }">
                </el-cascader>
            </el-form-item>
            <el-form-item label="ご担当者名" prop="person_charge">
                <el-input placeholder="那須与一" v-model="frmRegist.person_charge"></el-input>
            </el-form-item>
            <el-form-item label="メールアドレス" prop="mail_address">
                <el-input placeholder="user@example.com" v-model="frmRegist.mail_address"></el-input>
            </el-form-item>
            <el-form-item label="パスワード" prop="password">
                <el-input placeholder="8文字以上" v-model="frmRegist.password" show-password autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="パスワード（確認）" prop="checkPass">
                <el-input placeholder="確認のため再入力してください。" v-model="frmRegist.checkPass" show-password autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="個人情報の取扱い" prop="agree">
                <el-checkbox label="同意する" v-model="frmRegist.agree"></el-checkbox>
                （<a href="https://post-express.jp/privacy/" target="_blank">プライバシーポリシー <i class="fas fa-external-link-alt"></i></a>）
            </el-form-item>
            <el-form-item>
                <el-alert :title="message" type="error" v-if="message"></el-alert>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">登録</el-button>
                <el-button @click="resetForm">Cancel</el-button>
            </el-form-item>
        </el-form>
        </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { Regist } from '@/types/Regist';
import { business_options } from '@/business.ts';
import { app } from '../main';

export default defineComponent({
  setup() {
    const router = useRouter()
    const internalInstance = getCurrentInstance()
    const refFrmRegist: any = ref(null)
    const message = ref('')
    const frmRegist: Regist = reactive({
        corporate_name: '',
        postal_code: '',
        address: '',
        tel: '',
        business: '',
        person_charge: '',
        mail_address: '',
        password: '',
        checkPass: '',
        agree: false,
    })
    const checkAgree = (rule: any, value: string, callback: any) => {
        if(!value) {
            return callback(new Error('個人情報の取扱いについて確認してください。'));
        }else {
            callback();
        }
    }
    const validatePass2 = (rule: any, value: string, callback: any) => {
        if(value === '') {
          callback(new Error('確認用パスワードを入力してください。'));
        }else if(value !== frmRegist.password) {
          callback(new Error('2回入力されたパスワードが一致しません。'));
        }else {
          callback();
        }
    }
    const rules = {
        postal_code: [
        { required: true, message: '郵便番号を入力してください。', trigger: 'blur' },
        { min: 8, message: '文字数が不足しています（123-4567）。', trigger: 'blur' }
        ],
        address: [
        { required: true, message: '住所を入力してください。', trigger: 'blur' },
        ],
        tel: [
        { required: true, message: '電話番号を入力してください。', trigger: 'blur' },
        { min: 8, message: 'Length should be 8', trigger: 'blur' }
        ],
        business: [
        { required: true, message: '業種を選択してください。', trigger: 'change' }
        ],
        person_charge: [
        { required: true, message: 'ご担当者名を入力してください。', trigger: 'blur' },
        ],
        mail_address: [
        { required: true, message: 'メールアドレスを入力してください。', trigger: 'blur' },
        ],
        password: [
        { required: true, message: 'パスワードを入力してください。', trigger: 'blur' },
        { min: 8, message: '8文字以上必要です。', trigger: 'blur' }
        ],
        checkPass: [
        { validator: validatePass2, trigger: 'blur' }
        ],
        agree: [
        { validator: checkAgree, trigger: 'blur' },
        ],
    }
    const resetForm = () => {
        refFrmRegist.value.resetFields()
    }
    const submitForm = () => {
        const api_path = internalInstance?.appContext.config.globalProperties.api_path
        refFrmRegist.value.validate((valid: boolean) => {
            if(valid) {
                fetch(api_path + 'ajax/regist_user.php', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(frmRegist)
                })
                .then(response => response.json())
                .then(json => {
                    //console.log(json);
                    if(json['result'] == 'failure') {
                        throw new Error(json.error)
                    }
                    message.value = ""
                    app.config.globalProperties.$alert(
                        '登録したメールアドレスに確認メールを送信しました。リンクをクリックして確認処理を完了させてください。',
                        '会員登録',
                        {
                            confirmButtonText: 'OK',
                            callback: null
                        }
                    );
                    refFrmRegist.value.resetFields();
                    router.push({ path: '/login' });
                })
                .catch(error => {
                    console.error(error)
                    message.value = error.message
                })
            }else {
                console.log('invalid')
            }
        })
    }
    return {
        refFrmRegist,
        frmRegist,
        rules,
        message,
        business_options,
        resetForm,
        submitForm
    }
  }
})
</script>

<style>
#regist {
    height: calc(100% - 69px);
    background-color: #ecf0f5;
    position: relative;
    overflow: auto;
}
#regist .el-form {
    text-align: left;
}
#regist .el-header {
    padding-top: 30px;
    color: #6f6f6f;
    font-size: larger;
    text-align: center;
}
#regist .el-container {
    width: 550px;
    margin: 0 auto;
}
#regist .el-cascader {
    width: 100%;
}
</style>